import { pagesApi } from "@/shared/services";

export const useResolveRoom = () => {
  const handleResolveRoomInfo = async ({ roomIds }: { roomIds: string[] }) => {
    try {
      const ids = roomIds.map((id) => {
        const parts = id.split(":");
        return parts.length > 1 ? parts.slice(1).join(":") : "";
      });
      const pages = await pagesApi.getCollaborationRoomTitles(ids);

      return ids.map((id: string) => {
        const page = pages.find(
          (p: { _id: string; title: string; room: string }) => p.room === id,
        );
        return {
          name: page?.title || "Unknown",
        };
      });
    } catch (error) {
      console.error(error);
      return roomIds.map(() => ({ name: "Unknown" }));
    }
  };

  return handleResolveRoomInfo;
};
